import { Breadcrumb, Typography } from 'antd';

import fallbackbanner from '@/assets/images/fallbackbanner.png';
import ImageRatio from '@/components/shared/ImageRatio';
import { getCdnUrl, openInNewTab } from '@/helpers';
import { ISchoolConfig } from '@/interfaces/upsell';
import { MAIN_SUBDOMAIN, DOMAIN } from '@/settings';
import styled, { StyledProp } from '@/styled';

import OfferContainer from '../Container';

const PortalConfig = (props: StyledProp & { schoolConfig: ISchoolConfig }) => {
  return (
    <OfferContainer
      className={props.className}
      centralized={!props.schoolConfig.banner_logo && !props.schoolConfig.highlight_banner ? 'textCenter' : null}
      image={
        <>
          <Breadcrumb
            className='portal-breadcrumbs'
            items={[
              {
                title: <Typography.Link>Nutror</Typography.Link>,
                onClick: () => openInNewTab(`https://${MAIN_SUBDOMAIN}${DOMAIN}`)
              },
              {
                title: props.schoolConfig.title
              }
            ]}
          />
          <img
            src={getCdnUrl(props.schoolConfig.highlight_banner, fallbackbanner)}
            alt={'Imagem do portal: ' + props.schoolConfig.title}
          />
        </>
      }
    >
      <>
        <Typography.Title level={1} ellipsis>
          {props.schoolConfig.title}
        </Typography.Title>
        {props.schoolConfig.banner_logo && (
          <div className='logo'>
            <ImageRatio
              aspect='16:9'
              src={getCdnUrl(props.schoolConfig.banner_logo, fallbackbanner)}
              alt={'Imagem logo do portal ' + props.schoolConfig.title}
            />
          </div>
        )}
      </>
    </OfferContainer>
  );
};
export default styled(PortalConfig)`
  position: relative;

  .logo {
    max-width: 276px;

    > div:first-child {
      background: transparent;
    }

    ${({ theme }) => theme.breakpoints.down('xlg')} {
      max-width: 138px;
    }
  }

  h1 {
    ${({ theme }) => theme.breakpoints.down('md')} {
      font-size: ${({ theme }) => theme.space.pxToRem(20)};
    }
  }

  .portal-breadcrumbs {
    z-index: 5;
    width: 100%;
    position: absolute;
    margin-top: ${({ theme }) => theme.space.pxToRem(16)};
    margin-left: ${({ theme }) => theme.space.pxToRem(62)};

    ${({ theme }) => theme.breakpoints.down('md')} {
      display: none;
    }

    span,
    li {
      white-space: nowrap;
      width: fit-content !important;
    }
  }
`;
